export default __webpack_public_path__ + "static/media/Mark-2-HUD-Targeting (TD).782c5674.jpg";